import React from 'react'
import { Box, Grid, Flex } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'
import DateUtil from 'lib/date-util'
import { getLocale } from 'src/config/globals'
import routes from 'src/lib/rails-routes/rails-routes'

export type Props = {
  trialEndAt: string
}

const BannerTrial: React.FC<Props> = ({ trialEndAt }) => {
  const momentDate = DateUtil.dateFromISOString(trialEndAt, getLocale())
  return (
    <Flex
      width="100%"
      bg="yellow65"
      flexDirection="column"
      data-testid="BannerTrial"
      borderBottomRightRadius="0,5x"
      borderBottomLeftRadius="0,5x"
      alignItems="center"
    >
      <Grid
        justifyItems="center"
        alignItems="center"
        p="2,5x"
        gridTemplateColumns={{ _: '1fr', tablet: '1fr auto' }}
        gap="2x"
      >
        <Box as="p">
          {t('You have')}
          &nbsp;
          <Box as="span" fontWeight="bold">
            {t('%{formattedString} left', {
              formattedString: DateUtil.format(momentDate, 'fromNowSimple'),
            })}
          </Box>
          &nbsp;
          {t('in your trial subscription. ')}
        </Box>
        <Box
          as="a"
          href={routes.new_payments_subscription()}
          sx={{
            ':hover, :active, :focus': {
              color: 'black19',
              cursor: 'pointer',
            },
          }}
          variant="text.buttonTitle"
          target="_blank"
        >
          {t('See pricing plans')}
        </Box>
      </Grid>
    </Flex>
  )
}

export default BannerTrial
